module.exports = __webpack_public_path__ + "img/case15.23ef7381.jpg";